import { render } from "./YeniSurumUyarisi.vue?vue&type=template&id=d239f60a"
import script from "./YeniSurumUyarisi.vue?vue&type=script&lang=js"
export * from "./YeniSurumUyarisi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__